import { FC, Fragment } from 'react';
import { TeamChatTypes } from '@frontend/api-team-chat';
import { getUserFullName } from '../../../utils';
import { MentionTag } from './mention-tag';

interface MentionRendererProps {
  mentionText: string;
  currentUser?: TeamChatTypes.User;
  index: number;
  mentionUser?: TeamChatTypes.User;
}

/**
 * Renders a mention tag or fallback text
 */
export const MentionRenderer: FC<MentionRendererProps> = ({ mentionText, currentUser, index, mentionUser }) => {
  if (!mentionUser) {
    return <Fragment key={`mention-fallback-${mentionText}-${index}`}>{mentionText}</Fragment>;
  }

  const isSelf = mentionUser.userID === currentUser?.userID;

  return (
    <MentionTag
      key={`mention-${mentionText}-${index}`}
      label={`@${getUserFullName(mentionUser.firstName, mentionUser.lastName)}`}
      isSelf={isSelf}
    />
  );
};
